import React, { useCallback, useEffect, useState } from 'react';
import { Modal, Tappable } from '@vectord/components';
import cogoToast from 'cogo-toast';

import { useCreateAcademyTopicAcademyProjectMutation } from 'features/classCreation';
import Field from 'components/Field';
import GlobalLoader from 'components/GlobalLoader/GlobalLoader';
import Input from 'components/Input';
import styles from './CreateAcademyProjectModal.module.scss';

export default function CreateAcademyProjectModal({
  isOpen,
  handleClose,
  academyTopicId,
}) {
  const [academyProjectId, setAcademyProjectId] = useState();

  const [createAcademyProject, { isSuccess, error, isLoading: isCreating }] =
    useCreateAcademyTopicAcademyProjectMutation();

  const handleInputChange = useCallback((e) => {
    setAcademyProjectId(e.target.value);
  }, []);

  const handleOnClick = useCallback(() => {
    createAcademyProject({
      academyTopicId: Number(academyTopicId),
      academyProjectId,
    });
  }, [createAcademyProject, academyTopicId, academyProjectId]);

  useEffect(() => {
    if (isSuccess) {
      cogoToast.success('Case Study is successfully created!');
      handleClose();
    }
  }, [handleClose, isSuccess]);

  useEffect(() => {
    if (error) {
      cogoToast.error(
        error?.data?.message ||
          'There was some problem in creating the Case Study. Please try again later!'
      );
    }
  }, [error]);

  return (
    <Modal
      isOpen={isOpen}
      size="large"
      className="p-b-xs"
      unMountOnClose
      onClose={handleClose}
      title="Case Study"
    >
      <GlobalLoader isVisible={isCreating} />
      <Field
        name="title"
        label="Case Study slug ID"
      >
        <Input
          className={styles.inputField}
          placeholder="Case Study ID"
          value={academyProjectId}
          onChange={handleInputChange}
          disabled={isCreating}
        />
      </Field>
      <Tappable
        className="btn btn-primary btn-long m-t-xs"
        onClick={handleOnClick}
        disabled={isCreating}
      >
        Confirm
      </Tappable>
      <div className="h6 m-t-xs disabled">
        You can link case study to a class while scheduling
      </div>
    </Modal>
  );
}
